import UploadLogApi from '@/api/upload-log'
import { flushLog, scanLogFiles } from '@/logger'
import * as Sentry from '@sentry/vue'

const uploadLogs = async (_, { audienceId, presentationId }) => {
  try {
    // flush current buffer first
    await flushLog()

    // Get all log files
    const logFiles = await scanLogFiles()

    if (logFiles.length === 0) {
      return
    }

    // Create FormData for multipart upload
    const formData = new FormData()

    // Add log files to FormData
    logFiles.forEach((logFile) => {
      // Append each file with metadata as separate form fields
      formData.append('logFiles', logFile.file, logFile.name)
    })

    // Upload logs using multipart form data
    await UploadLogApi.sendLog(formData, { audienceId, presentationId })
  } catch (error) {
    Sentry.captureException(error)
  }
}

export default {
  uploadLogs,
}
